import classNames from "classnames";
import { CloseIcon } from "components/atoms/Icon";
import { Typography, TextArea, Button } from "components/atoms";
import { OnboardMessageBody, TextEditor } from "components/molecules";
import profileImage from "assets/profileImage.png";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const MessageBody = ({ theme }: IProps) => {
  function renderWithLineBreaks(text: string) {
    const withLineBreaks = text.replace(/\n/g, "<br/>");

    return withLineBreaks;
  }

  return (
    <div className="message-body-wrapper">
      <div className="header-section">
        <div className="left-section">
          <div className="profile-pic">
            <img src={profileImage} alt="" />
          </div>
          <div className="name-subject-section">
            <div className="name">
              <Typography
                label="Matthew Dempsey"
                variant="h6Medium"
                styles="custom-typography-style"
              />
            </div>
            <div className="subject">
              <Typography
                label="Subject: MCAT GChem Class 1"
                variant="h8Book"
                styles="custom-typography-style"
              />
            </div>
          </div>
        </div>
        <div className="right-section">
          <CloseIcon
            theme={theme}
            color="#9D9D9D"
            style="close-icon-custom-style"
          />
        </div>
      </div>
      <div className="body-section">
        <div className="display-area">
          <div className={classNames("onboard-message-wrapper")}>
            <OnboardMessageBody
              isSent={false}
              message={`Hi Mr. Dempey

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed facilisis ullamcorper lectus, at egestas magna iaculis nec. Suspendisse dignissim feugiat vehicula. Quisque venenatis tempus lorem, et rutrum sem viverra et. Curabitur fermentum id ex a fermentum. Suspendisse venenatis risus lectus, at feugiat ante porttitor at. Mauris fermentum sem turpis, sed pharetra libero luctus non. Suspendisse nunc eros, egestas in nisi vel, tempor finibus dolor. Vestibulum eu sem ut augue convallis maximus at id erat.

Thank you,
Cynthia`}
            />
            <OnboardMessageBody
              isSent={true}
              message={`Hi Cynthia

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed facilisis ullamcorper lectus, at egestas magna iaculis nec. Suspendisse dignissim feugiat vehicula. Quisque venenatis tempus lorem, et rutrum sem viverra et. Curabitur fermentum id ex a fermentum.`}
            />
          </div>
        </div>

        <div className="text-editor-section">
          <TextEditor />
        </div>
      </div>
    </div>
  );
};
